import {Vue} from 'ui.vue';


import './BXmakerAuthuseremailHeader.css';

Vue.component('BXmakerAuthuseremailHeader',
    {
        template: `
            <div class="bxmaker-authuseremail-header" >
                <slot /> 
            </div>
        `,
    });